/**
 * Rate limiting utility for file imports.
 * - Max 5 imports per 60 seconds.
 * - 30-second lockout if limit exceeded.
 */

class ImportRateLimiter {
  private imports: number[] = [];
  private lockoutUntil: number = 0;

  /**
   * Checks if an import is allowed.
   * Throws an error with a descriptive message if not allowed.
   */
  checkLimit() {
    const now = Date.now();

    // 1. Check lockout
    if (now < this.lockoutUntil) {
      const remainingSeconds = Math.ceil((this.lockoutUntil - now) / 1000);
      throw new Error(`Muitas importações. Por favor, aguarde ${remainingSeconds} segundos antes de tentar novamente.`);
    }

    // 2. Clean old imports (older than 60 seconds)
    this.imports = this.imports.filter(timestamp => now - timestamp < 60000);

    // 3. Check count
    if (this.imports.length >= 5) {
      this.lockoutUntil = now + 30000; // 30s timeout
      throw new Error("Limite de importação atingido (5 por minuto). Por favor, aguarde 30 segundos.");
    }

    // 4. Record new import
    this.imports.push(now);
  }

  getRemainingAttempts() {
    const now = Date.now();
    const recentImports = this.imports.filter(timestamp => now - timestamp < 60000);
    return Math.max(0, 5 - recentImports.length);
  }
}

export const importRateLimiter = new ImportRateLimiter();
